/**
 * Error thrown by direct (non-RTK) fetch/XHR sends for a non-2xx response.
 * The message is synthetic transport text (`Upload failed: 403 Forbidden`),
 * never a backend message, so UI code should branch on `status` and show its
 * own copy rather than echo `message`.
 */
export class HttpError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
  }
}
